

















































































































































































































































import Vue from "vue";
import LocalePrice from "@/lib/localePrice";
import StripePrice from "@/lib/stripePrice";
import Locale from "@/lib/locale";
import { Data, Method, Props } from "./PlanOptionDetailProV2VersionUp";
import SalePriceGuide from "./SalePriceGuide.vue";
import ForeignSalePriceGuide from "@/components/PlanOptionDetail/ForeignSalePriceGuide.vue";
import PlanOptionCreditCardV1 from "@/components/PlanOptionDetail/PlanOptionCreditCardV1.vue";
import PlanOptionPaypalCardV1 from "@/components/PlanOptionDetail/PlanOptionPaypalCardV1.vue";
import PlanOptionStoreCardV1 from "@/components/PlanOptionDetail/PlanOptionStoreCardV1.vue";
import { TextContainsLink as VcTextContainsLink } from "@/components";

export default Vue.extend<Data, Method, {}, Props>({
  name: "vc-plan-option-detail-pro-v2-version-up",
  components: {
    VcTextContainsLink,
    "vc-sale-price-guide": SalePriceGuide,
    "vc-foreign-sale-price-guide": ForeignSalePriceGuide,
    "vc-plan-option-credit-card-v1": PlanOptionCreditCardV1,
    "vc-plan-option-paypal-card-v1": PlanOptionPaypalCardV1,
    "vc-plan-option-store-card-v1": PlanOptionStoreCardV1
  },
  data() {
    var defaultCurrency = null;
    var defaultPrice = null;
    var defaultPriceText = null;
    var beforeDefaultPrice = null;

    for (const linkIndex in this.links) {
      if (this.links[linkIndex].currency == this.defaultCurrency) {
        defaultCurrency = this.links[linkIndex].currency;
        defaultPrice = this.prices[this.links[linkIndex].currency];
        beforeDefaultPrice = this.beforePrices[this.links[linkIndex].currency];
      }
    }
    if (defaultCurrency == null) {
      defaultCurrency = this.links[0].currency;
      defaultPrice = this.prices[this.links[0].currency];
      beforeDefaultPrice = this.beforePrices[this.links[0].currency];
    }

    const locale = Locale.getLocale();
    if (locale == "ja-jp") {
      defaultPrice = LocalePrice.getPrice(locale, Number(defaultPrice));
      beforeDefaultPrice = LocalePrice.getPrice(
        locale,
        Number(beforeDefaultPrice)
      );
    } else {
      defaultPrice = StripePrice.getPrice(
        defaultCurrency,
        Number(defaultPrice)
      );
      beforeDefaultPrice = StripePrice.getPrice(
        defaultCurrency,
        Number(beforeDefaultPrice)
      );
    }

    defaultPriceText = this.lang.note_price.replace(":price", defaultPrice);

    return {
      priceText: defaultPriceText,
      price: defaultPrice,
      beforePrice: beforeDefaultPrice,
      showDetail: this.initialShowDetail,
      currency: defaultCurrency,
      defaultLink: "",
      goldLink: "",
      locale: Locale.getLocale()
    };
  },
  props: {
    lang: { default: () => ({}) },
    paymentLang: { default: () => ({}) },
    prices: { default: () => ({}) },
    beforePrices: { default: () => ({}) },
    defaultCurrency: { default: "" },
    buttonMoreDetails: { default: "" },
    initialShowDetail: { default: false },
    isShowPlanList: { default: false },
    planListLink: { default: "" },
    planListText: { default: "" },
    isIce: { default: false },
    planKey: { default: "" },
    detailReplaceLink: { default: () => ({}) },
    links: { default: () => ({}) },
    fromPlanCategory: { default: undefined },
    isJapanSaleTarget: { default: false },
    isOverseasSaleTarget: { default: false },
    updatePlanLink: { default: "" },
    onetimePurchaseLink: { default: "" },
    target: { default: "" },
    discountRate: { default: () => ({}) }
  },
  mounted() {
    var defaultCurrencyIndex = 0;
    for (const linkNo in this.links) {
      if (this.links[linkNo].payment_method == "card_or_cs") {
        this.defaultLink = this.links[linkNo].url;
      } else if (this.links[linkNo].payment_method == "gold") {
        this.goldLink = this.links[linkNo].url;
      }
      if (this.currency == this.links[linkNo].currency) {
        defaultCurrencyIndex = Number(linkNo);
      }
    }
    if (this.defaultLink == "") {
      this.defaultLink = this.links[defaultCurrencyIndex].url;
    }
    if (this.isOverseasSaleTarget != false) {
      this.showDetail = true;
    }
  },
  computed: {
    goldPriceText(): string {
      return (
        Intl.NumberFormat("ja-JP").format(Number(this.prices["GOLD"])) + " GOLD"
      );
    },
    beforeGoldPriceText(): string {
      return (
        Intl.NumberFormat("ja-JP").format(Number(this.beforePrices["GOLD"])) +
        " GOLD"
      );
    },
    discountRateText(): string {
      return this.lang.sale.discount.replace(
        ":discount",
        this.discountRate["normal"][this.locale]
      );
    },
    goldDiscountRateText(): string {
      return this.lang.sale.discount.replace(
        ":discount",
        this.discountRate["gold"][this.locale]
      );
    }
  },
  methods: {
    async changeCurrency() {
      for (const linkNo in this.links) {
        if (this.currency == this.links[linkNo].currency) {
          this.price = StripePrice.getPrice(
            this.currency,
            Number(this.prices[this.links[linkNo].currency])
          );
          this.priceText = this.lang.note_price.replace(":price", this.price);
          this.beforePrice = StripePrice.getPrice(
            this.currency,
            Number(this.beforePrices[this.links[linkNo].currency])
          );
          this.defaultLink = this.links[linkNo].url;
        }
      }
    },
    async changeShowDetail() {
      this.showDetail = true;
    }
  }
});
